import { render } from "./Stack.vue?vue&type=template&id=1f6c5823&ts=true"
import script from "./Stack.vue?vue&type=script&lang=ts"
export * from "./Stack.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__